export enum PurchaseType {
    Ticket = 'ticket',
    Voucher = 'voucher',
}
